export default __webpack_public_path__ + "static/media/ultrasound-photo.08ce1c01.jpg";